<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.editButton">
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Edit RMA {{ rmaProduct.document_no }}
                      </h4>
                  </div><!--col-->
                  <div class="col-sm-7">
                    <div class="btn-toolbar float-right" role="toolbar" aria-label="Toolbar with button groups">
                        <b-button v-if="rmaProduct.action_buttons && rmaProduct.action_buttons.downloadDeliveryNote" variant="success ml-1" @click.stop.prevent="downloadDelivery(rmaProduct.document_no, rmaProduct.id)"><i class="fa fa-print"></i></b-button>
                    </div><!--btn-toolbar-->
                  </div><!--col-->
              </div><!--row-->

              <div class="row mt-4">
                  <div class="col">
                      <div class="form-group row">
                        <label for="marketplace_name" class="col-sm-2 col-form-label">
                          {{ $t('marketplace.marketplace_name') }}: {{ rmaProduct.platform }}
                        </label>
                        <label for="platform_order_id" class="col-sm-5 col-form-label">
                          {{ $t('marketplace.rma_product.platform_order_id') }}: {{ rmaProduct.platform_order_id }}
                        </label>
                      </div>
                      <div class="form-group row">
                        <label for="order_item_id" class="col-sm-2 col-form-label">
                          {{ $t('marketplace.rma_product.order_item_id') }}: {{ rmaProduct.order_item_id }}
                        </label>
                        <label for="imei_code" class="col-sm-5 col-form-label">
                          {{ $t('marketplace.rma_product.imei_code') }}: {{ rmaProduct.imei_code }}
                        </label>
                      </div>
                      <div class="form-group row">
                        <label for="product_name" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.product_name') }}</label>
                        <div class="col-sm-6">
                          <textarea rows="4" v-model.trim="rmaProduct.product_name" type="text" name="product_name" class="form-control" />
                        </div>
                      </div>
                       <div class="form-group row">
                        <label for="qty" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.qty') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.qty" type="number" name="qty" class="form-control" />
                        </div>
                        <label for="return_tracking_number" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.return_tracking_number') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.return_tracking_number" type="text" name="return_tracking_number" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="type" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.type') }}</label>
                        <div class="col-sm-3">
                           <select class="form-control" v-model="rmaProduct.type">
                            <option value="" key="1">Please select type</option>
                            <option value="1" key="2">RMA</option>
                            <option value="2" key="3"> RMA - Ageing</option>
                          </select>
                        </div>
                        <label for="return_requested_at" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.return_requested_at') }}</label>
                        <div class="col-sm-3">
                          <input v-model="returnRequestedDate" type="date" name="return_requested_at" class="form-control" />
                        </div>
                      </div>
                      <hr />
                      <h5 style="margin-top:20px; height:40px">Received Product Details</h5>
                      <div class="form-group row">
                        <label for="conditions" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.conditions') }}</label>
                        <div class="col-sm-3">
                           <select class="form-control" v-model="rmaProduct.conditions">
                            <option value="" key="1">Please select a Condition</option>
                            <option value="Good Condition" key="2">Good Condition</option>
                            <option value="Like New" key="3">Like New</option>
                            <option value="Damage" key="4">Damage</option>
                          </select>
                        </div>
                        <label for="warehouse_received_at" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.warehouse_received_at') }}</label>
                        <div class="col-sm-3">
                          <input v-model="warehouseReceivedDate" type="date" name="warehouse_received_at" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="cost" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.cost') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.cost" type="number" name="cost" class="form-control" />
                        </div>
                        <label for="selling_price" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.selling_price') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.selling_price" type="number" name="selling_price" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="deal_price" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.deal_price') }}</label>
                        <div class="col-sm-3">
                          <input v-model="rmaProduct.deal_price" type="number" name="deal_price" class="form-control" />
                        </div>
                        <label for="sold_date" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.sold_date') }}</label>
                        <div class="col-sm-3">
                          <input v-model="productSoldDate" type="date" name="sold_date" class="form-control" @change="()=>{
                            if(productSoldDate){
                              this.rmaProduct.status = 2
                            }
                          }"/>
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="remark" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.remark') }}</label>
                        <div class="col-sm-6">
                          <textarea rows="4" v-model.trim="rmaProduct.remark" type="text" name="remark" class="form-control" />
                        </div>
                      </div>
                      <div class="form-group row">
                        <label for="status" class="col-sm-2 col-form-label">{{ $t('marketplace.rma_product.status') }}</label>
                        <div class="col-sm-3" v-if="rmaProduct.status===3">
                           <select class="form-control" v-model="rmaProduct.status" disabled>
                            <option value=3 key="Settled">Settled</option>
                          </select>
                        </div>
                        <div class="col-sm-3" v-else>
                           <select class="form-control" v-model="rmaProduct.status">
                            <option value=1 key="Received">Received</option>
                            <option value=2 key="InProgress">Sold In Progress</option>
                          </select>
                        </div>
                      </div>
                  </div><!--col-->
              </div><!--row-->

              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> {{ $t('marketplace.rma_product.update') }}</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import loadingPanel from '@/components/LoadingPanel'
import moment from 'moment'

export default {
  name: 'RmaProductEdit',
  components: {
    loadingPanel
  },
  mounted () {
    this.fetchRmaOrderDetail();
  },
  data () {
    return {
      couriers: [],
      rmaProduct: {
        id: '',
        marketplace_id: '',
        platform: '',
        product_name: '',
        qty: 1,
        conditions: '',
        type: '',
        return_tracking_number: '',
        cost: '',
        selling_price: '',
        deal_price: '',
        sold_date: '',
        status: 0
      },
      returnRequestedDate: undefined,
      warehouseReceivedDate: undefined,
      productSoldDate: undefined,
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  methods: {
    fetchRmaOrderDetail(){
      this.axios.get('/marketplace/rma-product/' + this.$route.params.id).then(response => {
        this.rmaProduct = response.data
        this.returnRequestedDate = response.data.return_requested_at ? moment(response.data.return_requested_at).format('YYYY-MM-DD'): undefined
        this.warehouseReceivedDate = response.data.warehouse_received_at ? moment(response.data.warehouse_received_at).format('YYYY-MM-DD'): undefined
        this.productSoldDate = response.data.sold_date ? moment(response.data.sold_date).format('YYYY-MM-DD'): undefined
        if (this.rmaProduct.status === 1) {
          this.status = true
        }
      }).catch(error => {
        console.log(error)
      })
    },
    handleSubmit () {
      if (this.rmaProduct.id) {
        // create store
        this.showLoadingPanel = true
        this.axios.put('/marketplace/rma-product/' + this.rmaProduct.id, {
            ...this.rmaProduct,
            return_requested_at: this.returnRequestedDate,
            sold_date: this.productSoldDate,
            warehouse_received_at: this.warehouseReceivedDate
        }).then(response => {
          this.showLoadingPanel = false
          this.showAlert('success', this.$t('marketplace.rma_product.success_message'))
          this.message = response.data
          this.fetchRmaOrderDetail();
        }).catch(error => {
          this.showLoadingPanel = false
          this.showAlert('danger', error.data.message)
        })
      }
    },
    format (date) {
      return moment(date).format('YYYY-MM-DD')
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    },
    downloadDelivery (documentNo, id) {
    this.axios.get('/marketplace/rma-product/' + id + '/download-dn', {
      responseType: 'arraybuffer'
    }).then(response => {
      let blob = new Blob([response], { type: 'application/pdf' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = documentNo + '.pdf'
      link.click()
    }).catch(error => {
      console.log(error)
    })
  },
  },

}
</script>
